/**
 * useMontagemDoAviso — parte D1 (01/10/2026), extraído do `NotificationContext` na peça M do D3 (passo 19, 11/10/2026) para
 * o provedor do portal (`PortalAoVivo`) montar o MESMO aviso sem ter o contexto interno.
 *
 * O 1º gesto da aba libera o áudio e a põe na fila da vez de tocar; daí em diante todo gesto retoma o áudio que o navegador
 * tenha suspendido (iOS, ligação).
 * 🔴 A limpeza SOLTA a trava do som: "Sair" é navegação do SPA, o provedor desmonta e o documento fica; sem soltar, esta aba
 *    seguraria a vez de tocar e, entrando de novo por outra aba, ninguém tocaria. Na volta do provedor o 1º gesto registra e
 *    concorre de novo.
 * O contador do título ("(N) …") faz parte da montagem.
 */
import { useEffect } from "react";

import { useTituloDaAba } from "@/hooks/useTituloDaAba";
import { aoPrimeiroGesto } from "@/lib/avisos/primeiroGesto";
import { concorrerAoSom, soltarTravaDoSom } from "@/lib/avisos/travaDoSom";
import { desbloquearAudio, manterAudioRetomado } from "@/lib/somDeAviso";

export function useMontagemDoAviso(): void {
  useEffect(() => {
    const removerPrimeiroGesto = aoPrimeiroGesto(() => {
      desbloquearAudio();
      concorrerAoSom();
    });
    const removerRetomada = manterAudioRetomado();
    return () => {
      removerPrimeiroGesto();
      removerRetomada();
      soltarTravaDoSom();
    };
  }, []);
  useTituloDaAba();
}
